import type { FC } from 'react';
// biome-ignore lint/style/useImportType: legacy import, will be migrated
import * as React from 'react';

import { useTranslation } from '@crehana/i18n';
import Book from '@crehana/icons/Book';
import Bulb from '@crehana/icons/Bulb';
import Rocket from '@crehana/icons/outline/Rocket';
import PencilOutline from '@crehana/icons/PencilOutline';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { TextTag } from '@crehana/ui';

const icon = {
  herramientas: PencilOutline,
  ebooks: Book,
  'top-cases': Bulb,
  tutoriales: Rocket,
};

type TagsProps = {
  isNew: boolean;
  resourceCategory: string;
  category: string;
};

const Tags: FC<React.PropsWithChildren<TagsProps>> = ({
  isNew,
  resourceCategory,
  category,
}) => {
  const { t } = useTranslation();
  return (
    <div className="flex items-center mb-24">
      {isNew && (
        <TextTag
          label={t('RESOURCE_NEW')}
          className="capitalize mr-12"
          type="green"
        />
      )}
      {category && (
        <TextTag
          label={category}
          className="capitalize mr-12 bg-base-lighter"
          leftIcon={{
            component: icon[category as keyof typeof icon],
          }}
        />
      )}
      {resourceCategory && (
        <TextTag
          label={resourceCategory === 'B2B' ? 'NEGOCIOS' : resourceCategory}
          className="capitalize bg-gray-light text-base-main"
        />
      )}
    </div>
  );
};

export default Tags;
